var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Auth, Layout, Dependencies } from "~/core/decorator";
import BillComponents from "~/components/outsource-manage/outsource-reconciliation-manage/index";
import FileUpload from "~/components/common/file-upload.vue";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import { OutsourceService } from "~/services/domain-service/outsource.service";
import { OutsourceReconciliationManageService } from "~/services/domain-service/outsource-reconciliation-manage.service";
import { MENU_CHANNEL } from "~/config/enum.config";
import { State } from "vuex-class";
var OutsourceReconciliationManageIndex = /** @class */ (function (_super) {
    __extends(OutsourceReconciliationManageIndex, _super);
    function OutsourceReconciliationManageIndex() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.model = {
            outBatch: "",
            caseNumber: "",
            outId: "",
            checkStatus: "",
            entryTime: []
        };
        // 数据列表
        _this.dataSet = [];
        // 弹框控制
        _this.dialog = {
            openBillCheck: false,
            openCreatebill: false,
            openBillSurvey: false,
            openImportPayRecord: false,
            uploadFile: false
        };
        _this.checkModel = {};
        _this.fileList = [];
        _this.selectionList = [];
        _this.check = {};
        _this.rowData = null;
        _this.recCheckData = {}; //调账的参数
        return _this;
    }
    OutsourceReconciliationManageIndex.prototype.refreshData = function () {
        var _this = this;
        this.outsourceReconciliationManageService
            .caseOutContrastList(this.model, this.pageService)
            .subscribe(function (data) {
            _this.dataSet = data;
            _this.selectionList = [];
        });
    };
    /**
     * 对账单导出
     */
    OutsourceReconciliationManageIndex.prototype.exportBill = function () {
        var _this = this;
        if (this.dataSet.length === 0) {
            this.$message.info("暂无可导出的数据");
            return;
        }
        var text = "";
        var caseIds = [];
        var sum = this.selectionList.length;
        if (sum !== 0) {
            text = "已选择" + sum + "个案件，确认导出对账单?";
            caseIds = this.selectionList.map(function (v) { return v.id; });
        }
        else if (this.validateModel()) {
            text = "此操作将按照搜索过滤条件导出对账单，确认导出?";
        }
        else {
            text = "此操作将导出所有对账单，确认导出?";
        }
        var params = {
            caseIds: caseIds,
            batchNumber: this.model.batchNumber,
            checkStatus: this.model.checkStatus,
            entryTimeStart: this.model.entryTime[0],
            entryTimeEnd: this.model.entryTime[1],
            outId: this.model.outsName
        };
        this.$confirm(text, "导出对账单", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
        })
            .then(function () {
            _this.confirmExport(params);
        })
            .catch(function () {
            _this.$message.success("已取消");
        });
    };
    OutsourceReconciliationManageIndex.prototype.validateModel = function () {
        return (this.model.batchNumber ||
            this.model.caseNumber ||
            this.model.outId ||
            this.model.checkStatus ||
            this.model.entryTime.length !== 0);
    };
    /**
     * 确认导出对账单
     */
    OutsourceReconciliationManageIndex.prototype.confirmExport = function (data) {
        var _this = this;
        this.outsourceReconciliationManageService
            .exportBills(data, true)
            .subscribe(function (data) { return _this.$common.downloadFile(data.url); });
    };
    /**
     * 进入查看执行页
     */
    OutsourceReconciliationManageIndex.prototype.openExecutionPage = function (row) {
        this.$router.openCaseDetail(row.id, {
            menuChannel: MENU_CHANNEL.Outsource_checking,
            hiddenCaseList: true,
            hiddenAction: true
        });
    };
    OutsourceReconciliationManageIndex.prototype.mounted = function () {
        this.refreshData();
    };
    __decorate([
        Dependencies(OutsourceReconciliationManageService)
    ], OutsourceReconciliationManageIndex.prototype, "outsourceReconciliationManageService", void 0);
    __decorate([
        Dependencies(OutsourceService)
    ], OutsourceReconciliationManageIndex.prototype, "outsourceService", void 0);
    __decorate([
        Dependencies(PageService)
    ], OutsourceReconciliationManageIndex.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], OutsourceReconciliationManageIndex.prototype, "sortService", void 0);
    __decorate([
        State
    ], OutsourceReconciliationManageIndex.prototype, "outSourceList", void 0);
    OutsourceReconciliationManageIndex = __decorate([
        Auth(1007),
        Layout("workspace"),
        Component({
            components: __assign({ FileUpload: FileUpload }, BillComponents)
        })
    ], OutsourceReconciliationManageIndex);
    return OutsourceReconciliationManageIndex;
}(Vue));
export default OutsourceReconciliationManageIndex;
